import React, { useEffect, useState } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useDataProvider,
  useRefresh,
  DateInput,
} from "react-admin";
import Box from "@mui/material/Box";
import ItemSelectInput from '../../components/ItemSelectInput.tsx';
import { useParams } from 'react-router-dom';

const CustomerEdit: React.FC = () => {
  const dataProvider = useDataProvider();
  const [finishedGoods, setFinishedGoods] = useState<any[]>([]);
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const { id } = useParams(); // 获取当前编辑的ID

  return (
    <Edit key={id} mutationMode="pessimistic">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }}>
        <Box display="flex" width='100%' gap={2}>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="customerName" label="customerName" fullWidth />
          </Box>

          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="email" label="email" fullWidth />
          </Box>


        </Box>
        <Box display="flex" width='100%' gap={2}>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="phone" label="phone" fullWidth />
          </Box>


        </Box>
        <Box display="flex" width='100%' gap={2}>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="building" label="building" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="road" label="road" fullWidth />
          </Box>

        </Box>
        <Box display="flex" width='100%' gap={2}>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="city" label="city" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="country" label="country" fullWidth />
          </Box>

        </Box>



        <Box display="flex" width='100%' gap={2}>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="attn" label="attn" fullWidth />
          </Box>
          <Box flex="1 1 48%">
            <TextInput sx={{ mt: 1 }} source="fax" label="fax" fullWidth />
          </Box>

        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default CustomerEdit;